import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';

const BetslipLoadable = Loadable({ loader: imports.betslip, loading: () => null, exp: Exp => Exp.Betslip });

export default BetslipLoadable;
